import './loader.styles.scss';
export const Loader = () => {
  return (
    <>
      <div className="loader-container">
        <span class="loader"></span>
        <p> Scraping your provided pdf for texts and images...</p>
      </div>
    </>
  );
};
